import { Component, OnInit } from '@angular/core';
import { cardDeleteActionIcon } from '../../../../../global.variable';
import { AddEditServiceTypeComponent } from '../../../../shared/components/add-edit-service-type/add-edit-service-type.component';
import { ConfirmDialogComponent } from '../../../../shared/components/confirm-dialog/confirm-dialog.component';
import { ModalDialogueService } from '../../../../shared/components/modal-dialogue/modal-dialogue.service';
import { LoadingSpinnerService } from '../../../../shared/services/loading-spinner.service';
import { ToasterService } from '../../../../shared/services/toaster.service';
import { ClientsService } from '../../clients/clients.service';

@Component({
  selector: 'gtapp-service-type',
  templateUrl: './service-type.component.html',
  styleUrl: './service-type.component.scss',
  standalone: false,
})
export class ServiceTypeComponent implements OnInit {
  cardDetails = {
    individualDetails: [
      {
        name: 'name',
        cardRowStyle: {
          'font-weight': 'bolder',
          'padding': '1rem',
          'display': 'flex',
        },
      },
    ],
  };

  serviceTypeList: any = [];
  initialList: any = [];

  dialogref: any;
  cardActionIcons = cardDeleteActionIcon;

  serviceTypeDropDownList: any = [];
  constructor(
    private clientService: ClientsService,
    private spinnerService: LoadingSpinnerService,
    private dialogService: ModalDialogueService,
    private toasterService: ToasterService,
  ) {}

  ngOnInit(): void {
    this.spinnerService.show();
    this.fetchServiceTypeList();
  }

  fetchServiceTypeList() {
    let params: any = {};

    this.spinnerService.show();
    this.clientService.fetchServiceTypeList(params).subscribe((res: any) => {
      if (res['status'] == 'success') {
        this.serviceTypeList = res?.data;

        this.initialList = res?.data;
      }
      this.spinnerService.hide();
    });
  }
  onServiceTypeLookup(event: any) {
    if (event.target.value.length) {
      this.serviceTypeDropDownList = this.initialList?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event.target.value?.toLowerCase()),
      );
    }
  }
  filterResults(event: any) {
    if (event) {
      this.serviceTypeList = this.initialList?.filter((type: any) =>
        type?.name?.toLowerCase()?.includes(event?.toLowerCase()),
      );
    } else {
      this.serviceTypeList = this.initialList;
    }
  }

  openAddServiceTypeForm() {
    this.dialogref = this.dialogService.open(AddEditServiceTypeComponent, {
      data: { updateView: false },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value != 'close') {
        this.fetchServiceTypeList();
      }
    });
  }
  openEditServiceTypeForm(data: any) {
    this.dialogref = this.dialogService.open(AddEditServiceTypeComponent, {
      data: { updateView: true, responseData: data },
    });
    this.dialogref.afterClosed().subscribe((value: any) => {
      if (value != 'close') {
        this.fetchServiceTypeList();
      }
    });
  }
  deleteServiceType(data: any) {
    let dialogMsg = 'WARNING: This action cannot be reversed.';
    const dialogRef = this.dialogService.open(ConfirmDialogComponent, {
      data: {
        title: 'Delete Response Type',
        message: dialogMsg,
      },
    });
    dialogRef.afterClosed().subscribe((value) => {
      if (value === true) {
        this.spinnerService.show();
        this.clientService
          .deleteServiceType(data.id, { delete: 1 })
          .then((response: any) => {
            if (response['status'] == 'success') {
              this.fetchServiceTypeList();
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: response['message'],
                errorMessage: '',
              });
            } else {
              this.spinnerService.hide();
              this.toasterService.setMessage({
                successMessage: '',
                errorMessage: response['message'],
              });
            }
          });
      }
    });
  }
  onCloseDialogue() {
    this.dialogref.close();
  }
}
